module.exports = __webpack_public_path__ + "static/media/rocroi-logo.8a9e016f.png";